/** 七种折法的二维示意图（小 SVG），用于选择器与教程。
 * 只画"折后手上的形状"与该折法的折线，不做三维模拟。
 */
import type { FoldId, FinishedSize } from '../domain/types';
import { getFold } from '../domain/folds/definitions';
import { paperGeometry } from '../domain/folds/geometry';
import { boundsOf, polygonToPath } from '../domain/geometry/polygon';
import { viewBoxFromBounds } from '../editor/view';

export function FoldDiagram({ foldId, size, className }: { foldId: FoldId; size: FinishedSize; className?: string }) {
  const fold = getFold(foldId);
  const geo = paperGeometry(foldId, size);
  const b = boundsOf(geo.editable);
  const vb = viewBoxFromBounds(b, 4);
  const r = Math.max(b.maxX - b.minX, b.maxY - b.minY);
  return (
    <svg viewBox={vb} className={className} role="img" aria-label={`${fold.name}折后形状示意图`} preserveAspectRatio="xMidYMid meet">
      <path d={polygonToPath(geo.editable)} fill="#fdf6ec" stroke="#b9ad99" strokeWidth={0.8} vectorEffect="non-scaling-stroke" />
      <g opacity={0.55}>
        {geo.creaseAnglesDeg.map((deg, i) => {
          const rad = (deg * Math.PI) / 180;
          return (
            <line
              key={`${deg}-${i}`}
              x1={-Math.cos(rad) * r}
              y1={-Math.sin(rad) * r}
              x2={Math.cos(rad) * r}
              y2={Math.sin(rad) * r}
              stroke="#8a8a8a"
              strokeWidth={0.5}
              strokeDasharray="2 1.5"
              vectorEffect="non-scaling-stroke"
            />
          );
        })}
      </g>
      <circle cx={0} cy={0} r={1.4} fill="#d9483b" />
    </svg>
  );
}